module.exports = __webpack_public_path__ + "img/Popup_Akteure1.407cff44.png";